import React, { useRef, useEffect, useState, Suspense, useMemo } from "react";
import { TransformControls, PivotControls, Plane } from "@react-three/drei";
import { useXR, useXREvent } from "@react-three/xr";
import { Text } from "@react-three/drei"; 
import { useObjectStore } from "../zustand/objects";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";

import debounce from 'lodash.debounce';


import VRControls from "./VRControls";
import { matrix4FromState } from "../utils/matrix4FromState";

export const TextObject = ({ content, orbitControls, id, currentObjectArtboard, objectsAreLoaded, colour, bGColour, isLocked, matrixState }) => {

  const {
    updateObjectSelected,
    selectedObjectID,
    transformMode,
    updateObjectMatrix,
    transformModeChange,
    setIsDraggingModel,
    isDraggingModel,
    projectKey,
    arrangeUndoRedo
  } = useObjectStore();

  const transformControls = useRef();
  const transformChild = useRef();
  const textRef = useRef(); 

  const clickedShape = () => {
    // !isLocked && !isDraggingModel && updateObjectSelected(id)
    if (isDraggingModel === false) {
      !isLocked ? updateObjectSelected(id) : updateObjectSelected('0')  }
  };

// useEffect(() => { 
// // console.log(transformChild.current)
//  if (transformMode === "scale") { if (!isLocked) {
//    if (transformControls.current) {
//      const controls = transformControls.current;
//      const callback = (event) => {
//        orbitControls.current.enabled = !event.value;
//        if (controls.dragging === false) {
//          ObjectScaleUpdate()

//        }
//      };
//      controls.addEventListener("dragging-changed", callback);
//      return () => controls.removeEventListener("dragging-changed", callback);
//    }
//  }}
// });


 // declare empty position, rotation and scale for .decompose()
 const pos =  new THREE.Vector3()
 const rot = new THREE.Quaternion()
 const sca = new THREE.Vector3()
 
 const newMatrix = matrix4FromState(matrixState);
 
 // decompose newMatrix and apply to pos, rot and sca
 newMatrix.decompose(pos, rot, sca)
 
const [interimMatrix, setInterimMatrix] = useState(() => matrix4FromState(matrixState))

const startDragging = () => {
  setIsDraggingModel(true)
}

const stopDragging = () => {
  setIsDraggingModel(false)
}

const handleDragging = useMemo(
  () =>
    debounce((e) => {
      if (selectedObjectID === id) {
        setInterimMatrix(e);
      }
    }, 30),
  [id, selectedObjectID]
);

useEffect(() => {
  return () => handleDragging.cancel();
}, [handleDragging]);



const ObjectUpdate = (e) => {
  const pos2 = new THREE.Vector3()
  const rot2 = new THREE.Quaternion()
  const sca2 = new THREE.Vector3()
  const toDecompose = matrix4FromState(e)
  toDecompose.decompose(pos2, rot2, sca2)
   // send current state to undoActions
   arrangeUndoRedo({
    updateType: "objectUpdate", 
    artboard: currentObjectArtboard, 
    objectID: id,
    undo:false, 
    projectKey: projectKey, 
    field: "matrixState",
    })
    // send update to zustand
  updateObjectMatrix({
    id,
    currentObjectArtboard,
    matrix: e,
    undo: false
    // matrix: new THREE.Matrix4().compose(pos2, rot2, sca2),
    // matrix: new THREE.Matrix4().copy(e),
  })
  // setStateGrabbed(new THREE.Matrix4().copy(e))
  // before changed scale to make sure gizmo is right but not skewed in scale,
  // but now we're carrying the gizmo's matrix anyway, can just use e as is
  // setGizmoMatrixx(e)
  // setGizmoMatrixx(e)
  // setGizmoMatrixx(new THREE.Matrix4().compose(pos2, rot2, new THREE.Vector3(1, 1, 1)))

  
  // const toDecompose = new THREE.Matrix4().copy(transformChild.current.matrixWorld)
  
  // setGizmoMatrixx(new THREE.Matrix4().compose(pos2, rot2, new THREE.Vector3(1, 1, 1)))
}




 const missedShape = () => {
  !isDraggingModel && updateObjectSelected('0')
  transformModeChange({
    transformMode: "translate"
  })
};


    
const grabcontrols = useRef()
    
async function updatePositionVR() {
   // send current state to undoActions
   arrangeUndoRedo({
    updateType: "objectUpdate", 
    artboard: currentObjectArtboard, 
    objectID: id,
    undo:false, 
    projectKey: projectKey, 
    field: "matrixState",
    })
    // send update to zustand
  updateObjectMatrix({
    id,
    currentObjectArtboard,
    matrix: matrix4FromState(grabcontrols.current?.matrixWorld),
    undo: false
  })
}


const [vrSelected, setVrSelected] = useState(false)

const xr = useXR()

const handleVRSelectEnd = () => {
if (xr.isPresenting) {
     if (vrSelected){
     updatePositionVR().then(() => grabcontrols.current.position.set(
       0,0,0
     )).then(() => grabcontrols.current.rotation.set(
      0,0,0
    )).then(() => setVrSelected(false))
}
  }
}

useXREvent('selectend', () => handleVRSelectEnd())



  if (!objectsAreLoaded) {
    return <div>Loading...</div>;
  } else {
    return ( 
      selectedObjectID === id ? !isLocked ? transformMode === "translate" ?
      <group onPointerMissed={(e) => {
          // e.stopPropagation()
          missedShape()
        }}>
      <PivotControls
      depthTest={false}
      lineWidth={5}
      matrix={!isDraggingModel && matrix4FromState(matrixState)}
      active={selectedObjectID === id ? [true, true, true ] : [false, false, false]}

      onDragStart={() => startDragging()}
      onDragEnd={() => {
        ObjectUpdate(interimMatrix)
        stopDragging()}}
      onDrag={(e) => handleDragging(e)}

      ref={transformControls}
      visible={selectedObjectID === id ? true : false}
      fixed={true}
      scale={150}
      >
        <group ref={transformChild}>
        <Suspense fallback={null}>
        <Text
            // scale={[2.5, 2.5, 2.5]}
            fontSize={0.1}
            scale={[1,1,1]}
            position={[0, 0.125, 0]}
            anchorX={0.5} // default
            anchorY={-0.35} // default
            overflowWrap="break-word"
            maxWidth={1}
            clipRect={[-0.5,-0.595,1,1]}
            wrap={true}
            onClick={clickedShape}
            color={colour}
          >
          {content}
        </Text>
        {bGColour !== " " && <Plane 
          onClick={clickedShape} smoothness={4} scale={[1,1,1]} position={[0,0,-0.01]}>
              <meshPhongMaterial
                receiveShadow
                attach="material"
                opacity={1} 
                color={bGColour}
                side={THREE.DoubleSide}
              />
            </Plane>}
        </Suspense>
        </group>
      </PivotControls></group>
      :
      <group onPointerMissed={() => {
        missedShape()
      }}>
        <TransformControls
        position={objectsAreLoaded && new THREE.Vector3().setFromMatrixPosition(newMatrix)}
        // rotation={objectsAreLoaded && new THREE.Euler().setFromRotationMatrix(matrixState)}
        rotation={objectsAreLoaded && new THREE.Euler().setFromQuaternion(rot)}
        scale={objectsAreLoaded && new THREE.Vector3().setFromMatrixScale(newMatrix)}
        showY={false}
        showX={false}
        showZ={false}
        // showX={selectedObjectID === id && (transformMode === "translate" || transformMode === "scale") ? true : (category === "shape") ? selectedObjectID === id && true : false}
        // showZ={selectedObjectID === id && (transformMode === "translate" || transformMode === "scale") ? true : false}
        translationSnap={0.125}
        // rotationSnap={0.31416}
        scaleSnap={0.025}
        ref={transformControls}
        mode={'scale'}  
      >
        <group ref={transformChild}>
        <Suspense fallback={null}>
        <Text
            // scale={[2.5, 2.5, 2.5]}
            fontSize={0.1}
            scale={[1,1,1]}
            position={[0, 0.125, 0]}
            anchorX={0.5} // default
            anchorY={-0.35} // default
            overflowWrap="break-word"
            maxWidth={1}
            clipRect={[-0.5,-0.595,1,1]}
            wrap={true}
            onClick={clickedShape}
            color={colour}
          >
          {content}
        </Text>
        {bGColour !== " " && <Plane 
          onClick={clickedShape} smoothness={4} scale={[1,1,1]} position={[0,0,-0.01]}>
              <meshPhongMaterial
                receiveShadow
                attach="material"
                opacity={1} 
                color={bGColour}
                side={THREE.DoubleSide}
              />
            </Plane>}
        </Suspense>
        </group>
        </TransformControls></group>
      :
      <group onPointerMissed={() => {
        missedShape()
      }}>
        <TransformControls
      // position={objectsAreLoaded && new THREE.Vector3().setFromMatrixPosition(matrixState)}
      // rotation={objectsAreLoaded && new THREE.Euler().setFromRotationMatrix(matrixState)}
      // scale={objectsAreLoaded && new THREE.Vector3().setFromMatrixScale(matrixState)}
        showY={false}
        showX={false}
        showZ={false}
        translationSnap={0.125}
          // rotationSnap={0.31416}
          scaleSnap={0.025}
        ref={transformControls}
        mode={transformMode}
        matrixWorld={matrix4FromState(matrixState)}
      >
        <Text
            // scale={[2.5, 2.5, 2.5]}
            fontSize={0.1}
            scale={[1,1,1]}
            position={[0, 0.125, 0]}
            anchorX={0.5} // default
            anchorY={-0.35} // default
            overflowWrap="break-word"
            maxWidth={1}
            clipRect={[-0.5,-0.595,1,1]}
            wrap={true}
            onClick={clickedShape}
            color={colour}
          >
          {content}
        </Text>
        {bGColour !== " " && <Plane 
          onClick={clickedShape} smoothness={4} scale={[1,1,1]} position={[0,0,-0.01]}>
              <meshPhongMaterial
                receiveShadow
                attach="material"
                opacity={1} 
                color={bGColour}
                side={THREE.DoubleSide}
              />
            </Plane>}
      </TransformControls></group>
        :
        <VRControls 
          isLocked={isLocked}
          idprop={id}
          currentObjectArtboard={currentObjectArtboard}
          objectsAreLoaded={objectsAreLoaded}
          matrixState={matrix4FromState(matrixState)}
          // rot={rot}
          // scale={sca}
        >
          <Text
            // scale={[2.5, 2.5, 2.5]}
            fontSize={0.1}
            scale={[1,1,1]}
            position={[0, 0.125, 0]}
            anchorX={0.5} // default
            anchorY={-0.35} // default
            overflowWrap="break-word"
            maxWidth={1}
            clipRect={[-0.5,-0.595,1,1]}
            wrap={true}
            onClick={clickedShape}
            color={colour}
            ref={textRef}

          >
            {content}
          </Text>
         {bGColour !== " " && <Plane 
                onClick={clickedShape} smoothness={4} 
          scale={[1,1,1]} 
          position={[0,0,-0.01]}>
              <meshPhongMaterial
                receiveShadow
                attach="material"
                opacity={1} 
                color={bGColour}
                side={THREE.DoubleSide}
              />
            </Plane>}
        


        </VRControls>
    );
  }
};

export const GroupedTextObject = ({ content, orbitControls, undoing, position, rotation, scale, id, currentObjectArtboard, objectsAreLoaded, colour, isLocked, matrixState }) => {

  const {scene} = useThree();
  const modelRef = useRef()
  const {
    updateObjectSelected,
    transformModeChange
  } = useObjectStore();

  useEffect(() => {
    const group = scene.getObjectByName(id);
    if (!group || !modelRef.current) {
      return;
    }

    group.remove(modelRef.current);
    modelRef.current.applyMatrix4(matrix4FromState(matrixState));
    group.attach(modelRef.current);
  }, [id, matrixState, scene]);


const missedShape = () => {
  updateObjectSelected('0')
  transformModeChange({
    transformMode: "translate"
  })
};

  if (!objectsAreLoaded) {
    return <div>Loading...</div>;
  } else {
    return ( 
      
      <group
      ref={modelRef}
      scale={objectsAreLoaded && new THREE.Vector3().setFromMatrixScale(matrix4FromState(matrixState))}
      onPointerMissed={() => {
        missedShape()
      }}
      >
        <Suspense fallback={null}>
          <group>
        <Text 
          scale={[2.5, 2.5, 2.5]}
          position={[0,0.125,0]}
          // color="black" // default
          anchorX="center" // default
          anchorY="middle" // default
          overflowWrap="break-word"
          maxWidth={1}
          wrap={true}
          color={colour}
          >
          {content}
            </Text>
           
          </group>
        </Suspense>
      </group>




    );
  }
};
